import styled from "styled-components";
import { motion } from "framer-motion";

export const StyledSection = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  align-items: stretch;
  margin-top: 6px;
  padding: 0 20px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    margin-top: 16px;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }
`;

export const HeroContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: linear-gradient(to bottom, rgba(29, 29, 29, 0.04), #ffffff);
  border-radius: 32px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: none;
  flex-grow: 0;

  @media ${({ theme }) => theme.media.mobile} { 
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const BackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 1024px;
  left: 0;
  top: -59px;
  background-size: auto 100%;
  background-position: center;
  background-image: url(/images/backgrounds/hero-bg-2.webp);
  background-repeat: no-repeat;
  background-blend-mode: overlay;
  mix-blend-mode: soft-light;
  z-index: 1;

  @media ${({ theme }) => theme.media.mobile} {
    height: 1053px;
    top: -67px;
  }
`;

export const BlurOverlay = styled.div`
  position: absolute;
  width: calc(100% - 36px * 2);
  height: 160px;
  left: 36px;
  top: 416px;
  background-color: ${({ theme }) => theme.colors.blurBg.trim()};
  filter: blur(130px);
  border-radius: 59.0555px;
  opacity: 0.4;
  z-index: 0;

  @media ${({ theme }) => theme.media.mobile} {
    width: 515px;
    height: 110px;
    left: calc(50% - 515px / 2);
    top: 464px;
    filter: blur(200px);
    border-radius: 60px;
    opacity: 1;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`;

export const TitleContainer = styled.div`
  padding-top: 93px;
  padding-left: 24px;
  padding-right: 24px;
  width: calc(892px + 24px * 2);
  max-width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 46px;

  @media ${({ theme }) => theme.media.mobile} {
    padding-top: 80px;
    max-width: 100%;
    width: 100%;
    gap: 48px;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media ${({ theme }) => theme.media.mobile} {
    gap: 16px;
  }
`;

export const HeaderTitle = styled(motion.h1)`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 64px;
  line-height: 1.2em;
  letter-spacing: -0.02em;
  color: rgba(29, 29, 29, 0.85); // #1d1d1dd9
  margin: 0;
  position: relative;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 36px;
    line-height: 1.3em;
    letter-spacing: unset;

    br {
      display: none;
    }
  }
`;

export const HeaderSubtitle = styled(motion.p)`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 20px;
  line-height: 1.5;
  color: rgba(29, 29, 29, 0.85);
  margin: 0 auto;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 16px;
  }
`;

export const ArrowIcon = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-top: 2px solid white;
  border-right: 2px solid white;
  transform: rotate(45deg);
`;
